<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_terms_TermsService.1')"
       id="terms-agreement-terms-service-title"
      ></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="agree-scroll-content">
          <section class="-wrapper-column -wrapper-tile -width-100">
            <div class="-header">
              <p class="-h2"
                id="terms-agreement-terms-service-header"
              >{{$t('pages_terms_TermsService.1')}}</p>
            </div>
            <div class="-bg-white -p-5 -width-100">
              <iframe src="about:blank" ref="agreementFirst" style="width: 100%; border: 0;" :style="{height: iframeHeight}"
                id="terms-agreement-terms-service-ifame" title="agreementFirst"></iframe>
            </div>
          </section>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  data () {
    return {
      iframeHeight: '0px'
    }
  },
  computed: {
    ...mapGetters('terms', ['agreementFirst'])
  },
  methods: {
    ...mapActions('terms', ['getAgreementList']),
    onResizeWindow () {
      const windowDocument = this.$refs.agreementFirst.contentDocument
      const iframeRect = windowDocument.body.getBoundingClientRect()
      this.iframeHeight = (iframeRect.height + 40) + 'px'
    }
  },
  watch: {
    agreementFirst () {
      const windowDocument = this.$refs.agreementFirst.contentDocument
      windowDocument.body.innerHTML = this.agreementFirst.terms
      const iframeRect = windowDocument.body.getBoundingClientRect()
      this.iframeHeight = (iframeRect.height + 40) + 'px'
    }
  },
  beforeMount () {
    this.getAgreementList()
    window.addEventListener('resize', this.onResizeWindow)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResizeWindow)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/terms/TermsService.vue